import styled from 'styled-components'

import { Link } from '@reveni-io/reveni-ui'

export const LinkToSupport = styled(Link)`
  color: ${props => props.theme.colors.warning.onSurface};
`
